/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "./Creation.scss";
import "primeicons/primeicons.css";
import PropTypes from "prop-types";
// import { ScrollPanel } from "primereact/scrollpanel";
import { TabMenu } from "primereact/tabmenu";
import ActualitesCreation from "../ActualitesCreation/ActualitesCreation";
import { connect } from "react-redux";
import Margin from "Components/Stats/Margin";
import ConseilsCreation from "../ConseilsCreation/ConseilsCreation";

const Creation = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const getComponents = () => {
    switch (activeIndex) {
      case 0:
        return <ActualitesCreation />;
      default:
        return <ConseilsCreation />;
    }
  };
  const buttonsNav = ["Actualités", "Déposer des ressources et guides"];
  return (
    <div className="creation_page">
      <div className="creation_page__title">
        <h1 className="h1_trait_dessus">
          {props.items[props.activeIndex].label}
        </h1>
      </div>
      <div className="creation_page__article">
        <div className="creation_page__article__left">
          {props.auth.isAdmin &&
            buttonsNav.map((btn, index) => {
              return (
                <button
                  className={
                    activeIndex === index
                      ? "btn-bleu navBarGestionDroit__btn"
                      : "btn-blanc navBarGestionDroit__btn"
                  }
                  onClick={(e) => {
                    setActiveIndex(index);
                  }}
                  key={index}
                >
                  {btn}
                </button>
              );
            })}
        </div>
        <div className="creation_page__article__right">{getComponents()}</div>
      </div>
    </div>
  );
};

Creation.propTypes = {
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  auth: PropTypes.object,
};
const mapStateToProps = (state) => ({ auth: state.auth });

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Creation);
